import { enqueueSnackbar } from "notistack";
import { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { cafeDetail } from "../../../../api/cafe";
import {
  CurrentReservationDto,
  getReservation,
  getCurrentReservations,
  TournamentReservationRequest,
  CurrentReservationType,
  registerReservation,
  reservationCancel,
} from "../../../../api/reservation";
import { Cafe, ReservationResponse } from "../../../../api/types";
import { isApp } from "../../../../hooks/useNativeApp";
import { userState } from "../../../../recoil/auth";
import { useRecoilValue } from "recoil";

export const useReservation = () => {
  const { id } = useParams<{ id: string }>();
  const user = useRecoilValue(userState);
  const history = useHistory();
  const [pub, setPub] = useState<Cafe | null>(null);
  const [reservation, setReservation] = useState<ReservationResponse | null>(
    null
  );
  const [type, setType] = useState(CurrentReservationType.NORMAL);
  const [useAmount, setUseAmount] = useState<number>(0);
  const [isReservation, setIsReservation] = useState<boolean>(false);
  const [currentId, setCurrentId] = useState<number>(0);
  const [currentList, setCurrentList] = useState<CurrentReservationDto[]>([]);

  useEffect(() => {
    getReservationData();
    getCurrentData();
  }, [id]);

  const getReservationData = async () => {
    if (!id) return;
    getReservation(+id).then((reservation) => {
      setReservation(reservation);
      cafeDetail(reservation.cafeId).then(setPub);
      const amount = (reservation?.buyIn || 0) / 10000;
      setUseAmount(amount);
    });
  };

  const getCurrentData = async () => {
    if (!id) return;
    getCurrentReservations(+id).then((response) => {
      setCurrentList(response);
    });
  };

  useEffect(() => {
    if (!user) return;
    const isReservation = currentList.some(
      (item) => item.nickname === user.nickname
    );
    setIsReservation(isReservation);
    if (isReservation) {
      const reservation = currentList.find((item) => item.userId === user.id);
      if (reservation) {
        setCurrentId(+reservation.id);
      }
    }
  }, [currentList, user]);

  const handleReservation = async (value?: CurrentReservationType) => {
    if (!user) {
      enqueueSnackbar("로그인이 필요합니다. ", { variant: "error" });
      history.push("/login");
      return;
    }
    if (!user.validate) {
      enqueueSnackbar("가맹점에 방문하여 인증을 완료해주세요. ");
      return;
    }
    const body: TournamentReservationRequest = {
      reservationId: +id,
      nickname: user.nickname,
      phoneNumber: "",
      userId: user.id,
      route: isApp ? "APP" : "WEB",
      type: value ? value : type,
    };
    try {
      const response = await registerReservation(body);
      enqueueSnackbar(response.message);
      getReservationData();
      getCurrentData();
    } catch (error: any) {
      enqueueSnackbar(error.message, { variant: "error" });
    }
  };

  const handleCancel = async () => {
    if (!currentId) return;

    try {
      await reservationCancel(currentId);
      enqueueSnackbar("예약이 취소되었습니다. ");
      getCurrentData();
      getReservationData();
    } catch (e: any) {
      enqueueSnackbar(e.message, { variant: "error" });
    }
  };

  return {
    // 핸들러
    handleCancel,
    handleReservation,
    // 데이터
    reservation,
    pub,
    isReservation,
    currentList,
    useAmount,
    // 예약 타입
    type,
    setType,
  };
};
